<div class="container">
  <div class="row no-gutters">
    <div class="col-12">
      <div class="d-flex popup-head align-items-center">
        <div class="popup-title mr-auto" translate>lblAddKeyDropLocation</div>
        <div class="float-right">
          <a class="close mr-3" (click)="OnClose()" translate>
            <span class="" aria-hidden="true">&times;</span>
            </a>
        </div>
        
      </div>

      <form name="form" #f="ngForm">
        <div class="scrollbar">
          <div class="card-content">
            <div class="card-body p-0">
              <div class="row">
                <div class="col-md-6 af-form-group">
                  <label for="dealer" translate>lblSelectDealer <strong class="mlt6 required"> * </strong></label>
                  <div class="lbl-info">
                    <select class="form-control" [(ngModel)]="selectedDealerId" name="dealerName" #dealerName="ngModel"
                      [disabled]="selectedDealerId && service.isEdit? true:false"
                      [class.in-invalid]="dealerName.isvalid && dealerName.touched" required>
                      <option selected disabled [ngValue]="''" translate>
                        lblSelectDealer</option>
                      <option *ngFor="let dealer of dealerList" [ngValue]="dealer.value">{{dealer.text}}</option>
                    </select>
                    <div *ngIf="dealerName.touched && dealerName.errors?.required" class="help-block text-danger">
                      <span translate>lblPleaseSelectDealerName</span>
                    </div>
                  </div>
                </div>
                <div class="col-md-6 af-form-group">
                  <label for="name" translate>lblLocationName <strong class="mlt6 required"> *</strong></label>
                  <div class="lbl-info">
                    <input type="text" class="form-control" name="name" #name="ngModel" class="form-control"
                      [(ngModel)]="keyDropLocationViewModel.locationName" required maxlength="30">
                    <div *ngIf="name.invalid && (name.dirty || name.touched)" class="help-block text-danger">
                      <div *ngIf="name.errors.required"><span translate>lblNameRequired</span></div>
                    </div>
                  </div>
                </div>

                <div class="col-md-6 af-form-group">
                  <label for="name" translate>lblLocationType <strong class="mlt6 required"> *</strong></label>
                  <div class="row">
                    <div class="col" *ngFor="let location of locationList">
                      <div class="lbl-info form-check mt-1">
                        <input class="form-check-input" type="radio" value={{location.value}} name="locationType"
                          (click)="getValue(location.value)" id="locationType"> {{location.text}}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="p-3 bg-light pp-footer-top-brdr">
        <div class="row">
          <div class="col-12 d-flex flex-sm-row flex-column justify-content-end mb15">
            <button type="submit" class="btn btn-primary btn-lg mr-sm-2" aria-label="Center Align" (click)="Add(keyDropLocationViewModel)"
              [disabled]="!f.valid" translate>
              <em class="fa fa-plus font16 align-top mr-2"></em>
              lblAddKeyLocation
            </button>
            <a (click)="OnClose()" type="reset" class="btn btn-secondary btn-lg" translate><em class="far fa-times-circle font16 align-top mr-2"></em>lblCancel</a>
          </div>
        </div>
      </div>
      </form>
    </div>
  </div>
</div>